
export enum CoronaVirusStatus{
    Suspected="suspected",
    Confirmed="confirmed",
    None="none"
}
export interface PatientClinicalDetail {
    diet:string;
    specialNeeds:string;
    medicationNote:string;
    coronaVirusStatus?:CoronaVirusStatus;
    healthComment:string;
}